import styled from '@emotion/styled'
import { breakpoints, container, palette, spacing, Text, typography } from 'main/ui'

export const Container = styled.div`
  background-color: ${palette.white};
  display: flex;
  flex-direction: column;
`

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: -50px auto ${spacing.majorScale(4)}px auto;
  max-width: ${container.maxWidth.sm}px;
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    max-width: ${container.maxWidth.lg}px;
  }
`

export const LeftColumn = styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  margin-right: ${spacing.majorScale(4)}px;
`

export const RightColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const MobileColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 0 ${spacing.majorScale(1)}px;
`

export const DirectorProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: ${spacing.majorScale(3)}px;
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    justify-content: unset;
    margin: 0 auto 0 ${spacing.majorScale(8)}px;
  }
`

export const AvailabilityBadgeContainer = styled.div`
  margin-bottom: ${spacing.majorScale(4)}px;
  margin-left: ${spacing.majorScale(2)}px;
  margin-right: ${spacing.majorScale(2)}px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-left: 0;
    margin-right: 0;
  }
`

export const CTASectionContainer = styled.div`
  padding-bottom: ${spacing.minorScale(5)}px;

  > :not(:first-child):not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`

export const StyledText = styled(Text)`
  font-size: ${typography.fontSize.hint};
  text-align: center;
  padding: ${spacing.majorScale(1)}px;
`

export const QSPSectionContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const AchievementsContainer = styled.div`
  margin-bottom: ${spacing.majorScale(4)}px;
  margin-top: ${spacing.majorScale(2)}px;
`

export const PhotosContainer = styled.div`
  margin-bottom: ${spacing.majorScale(3)}px;
`

export const RatingsReviewsContainer = styled.div`
  margin: ${spacing.majorScale(2)}px 0;
`
